import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate, Link } from "react-router-dom";
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import logo from "../Assets/Logo/White Logo.png";

const Footer = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <footer className="bg-black text-white px-6 sm:px-10 lg:px-20 xl:px-24 py-12">

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 border-b border-white/20 pb-10">

        {/* LOGO + ABOUT */}
        <div>
          <img src={logo} alt="logo" className="w-40 mb-4" />
          <p className="text-sm leading-relaxed text-white">
            We are a full service digital marketing agency based in India.
            We combine our years of experience in creating integrated marketing
            solutions with creative output to generate superior ROI.
          </p>
        </div>



        {/* OTHER OFFICES */}
        {/* <div>
          <h3 className="text-lg font-semibold mb-3">Other Offices</h3>
          <div className="w-16 h-[2px] bg-[#FFF] mb-4"></div>

          <p className="text-sm text-white mb-2">
            <span className="font-medium text-white">New Delhi (India)</span><br />
            Saket, New Delhi
          </p>

          <p className="text-sm text-white mb-2">
            <span className="font-medium text-white">Dubai (UAE)</span><br />
            Business Bay, Dubai
          </p>

          <p className="text-sm text-white">
            <span className="font-medium text-white">Toronto (Canada)</span><br />
            Ontario, Canada
          </p>
        </div> */}

        {/* SERVICES */}
        <div>
          <h3 className="text-lg font-semibold mb-3 text-[#f99728]">Our Services</h3>
          <div className="w-16 h-[2px] bg-[#FFF] mb-4"></div>
          <ul className="space-y-2 text-sm text-white">
            <li className="hover:text-[#f99728] cursor-pointer">
              Social Media Marketing
            </li>

            <li className="hover:text-[#f99728] cursor-pointer">
              Search Engine Optimization (SEO)
            </li>

            {/* <li className="hover:text-[#f99728] cursor-pointer">
              Performance Marketing (PPC & Google Ads)
            </li> */}

             <li className="hover:text-[#f99728] cursor-pointer">
              Performance Marketing 
            </li>

            <li className="hover:text-[#f99728] cursor-pointer">
              Web Analytics
            </li>

            <li className="hover:text-[#f99728] cursor-pointer">
              Website Design & Development
            </li>

            <li className="hover:text-[#f99728] cursor-pointer">
              Website Management
            </li>

            <li className="hover:text-[#f99728] cursor-pointer">
              Email Marketing
            </li>

            <li className="hover:text-[#f99728] cursor-pointer">
              Graphic Design
            </li>
          </ul>
        </div>

        {/* REGISTERED OFFICE */}
        <div>
          <h3 className="text-lg font-semibold mb-3 text-[#f99728]">Registered Office</h3>
          <div className="w-16 h-[2px] bg-[#FFF] mb-4"></div>
          <p className="text-sm text-white">
            Shop No. 05, Gali No. 1,<br /> Kasana Market Surajpur, <br /> Greater Noida, Gautam Buddha Nagar,<br /> UP-201306,
          </p>

          {/* <h3 className="text-md font-semibold mb-3 mt-4">Registered Office (UAE)</h3>
          <div className="w-16 h-[2px] bg-[#FFF] mb-4"></div>
          <p className="text-sm text-white">
            Mezzanine Office, Business Bay <br />
            Dubai, UAE
          </p> */}
        </div>

        {/* CONTACT */}
        <div>
          <h3 className="text-lg font-semibold mb-3 text-[#f99728]">Connect With Us</h3>
          <div className="w-16 h-[2px] bg-[#FFF] mb-4"></div>

          <p className="text-sm font-bold text-[#f99728] mb-2">Get in touch</p>
          {/* <p className="text-sm hover:text-[#f99728] cursor-pointer">
            📞 +91 7834949503
          </p> */}
          <p className="text-sm flex items-center gap-2">
            <FaPhoneAlt className="text-[#FFF]" /> +91 78275 81749
          </p>

          <p className="text-sm font-bold mt-3 text-[#f99728] mb-2">Write to us</p>
          {/* <p className="text-sm hover:text-[#f99728] cursor-pointer">
            ✉️ sales@growthloomdigital.com
          </p> */}
          <p className="text-sm flex items-center gap-2">
            <FaEnvelope className="text-[#FFF]" /> info@growthloomdigital.com
          </p>
          <p className="text-sm flex items-center gap-2">
            <FaEnvelope className="text-[#FFF]" /> sales@growthloomdigital.com
          </p>
        </div>

      </div>

      {/* SOCIAL + COPYRIGHT */}
      <div className="flex flex-col md:flex-row justify-between items-center mt-6 gap-4">

        <div className="flex gap-4">
          <FaInstagram size={22} className="hover:text-[#f99728] cursor-pointer text-[#f99728]" />
          <FaFacebookF size={22} className="hover:text-[#f99728] cursor-pointer text-[#f99728]" />
          <FaTwitter size={22} className="hover:text-[#f99728] cursor-pointer text-[#f99728]" />
          <FaLinkedinIn size={22} className="hover:text-[#f99728] cursor-pointer text-[#f99728]" />
        </div>

        <p className="text-sm text-white">
          © 2026 <span className="text-[#f99728]">growthloomdigital</span>. All rights reserved.
        </p>

      </div>

    </footer>
  );
};

export default Footer;
